module.exports = __webpack_public_path__ + "img/0x81859801b01764D4f0Fa5E64729f5a6C3b91435b.0ec95308.png";